import i18n from "../i18n";

const theme = {
  colors: {
    background: "#FAFAFA",
    navbarBackgroundColor: "#12174E",

    primary: "#012F6B",
    lightPrimary: "#073d85",
    extralightPrimary: "#2E519F",
    transparentPrimary: "rgba(32, 53, 99, 0.4)",

    secondary: "#F6981E",
    lightSecondary: "#faa332",
    extraLightSecondary: "#fcb65b",
    transparentSecondary: "rgba(231, 139, 23, 0.4)",
    footerBackgroundColor: "#012F6B",

    // positive, negative and confirm/cancel
    red: "#E97DA0",
    green: "#9FCE67",
    errorRed: "#f5222d",

    // general
    white: "#FFFFFF",
    offWhite: "#F7F7F9",
    gray: "rgba(255,255,255,0.8)",
    lightGray: "rgba(255,255,255,0.9)",
    mediumGray: "#E1E1E2",
    black: "#4F4F4F",
    blackSecondary: "#8e8e8e",
    yellow: "#FFC107",
    transparent: "transparent",

    // transparent
    backgroundWashOut: "rgba(239, 239, 244, 0.6)",
  },

  fontFamily: {
    main: i18n.language === "en" ? "'Montserrat'" : "'Tajawal'",
    body: "'Roboto', sans-serif",
    code: "'Source Code Pro', monospace",
  },
  // 16px = 1rem
  font: {
    XXsmall: "0.875rem", // 14px
    Xsmall: "1rem", // 16px
    small: "1.125rem", // 18px
    med: "1.25rem", // 20px
    large: "1.5rem", // 24px
    Xlarge: "2rem", // 32px
    massive: "3rem", // 48px
  },
  breakpoint: {
    Xsmall: "480px",
    small: "600px",
    tablet: "768px",
    large: "1024px",
    Xlarge: "1280px",
    massive: "1440px",
  },
  shadow: {
    navbarShadow: " 0 2px 2px -2px rgba(0,0,0,.2)",
    primary: "0px 1px 4px rgba(0, 0, 0, 0.05)",
    secondary: "0px 3px 6px rgba(0, 0, 0, 0.07)",
  },
  sizes: {
    navbar: "8vh",
    extendNavbar: "100vh",
    buttonHeight: "2.8rem",
  },
};

export default theme;
